<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="5" class="d-flex align-center">
        <div>
          <h1 class="title font-weight-light mb-lg-1">
            <v-icon class="mb-1" left>mdi-format-list-bulleted</v-icon>
            {{ $t("URUNLER.LIST.TITLE") }}
          </h1>
          <div class="pr-lg-15 mb-1"></div>
          <p class="text-caption font-weight-light mb-0">{{ $t("URUNLER.LIST.SUB_TITLE") }}</p>
        </div>
      </v-col>
      <v-col cols="12" lg="7" class="d-flex align-end">
        <v-row class="mx-0">
          <v-col cols="12" lg="3" class="px-0 px-lg-1">
            <v-select
              solo
              dense
              :items="urunKategorileri"
              v-model="urunAraData.urunAraSelect"
              item-text="name"
              item-value="code"
              class="font-weight-light"
              :label="$t('URUNLER.LIST_SEARCHBOX.SEARCHBOX_SELECT_LABEL')"
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" lg="9" class="px-0">
            <v-text-field
              solo
              :hint="$t('URUNLER.LIST_SEARCHBOX.SEARCHBOX_INPUT_HINT')"
              dense
              :label="$t('URUNLER.LIST_SEARCHBOX.SEARCHBOX_INPUT_LABEL')"
              prepend-inner-icon="mdi-magnify"
              class="urun-ara-text-field font-weight-light"
              v-model="urunAraData.urunAraText"
              @keyup.enter="urunAraEnter"
              clearable
            >
              <template v-slot:append>
                <div class="d-flex align-center">
                  <v-btn-toggle v-model="urunAraData.urunAraType" dense borderless active-class="urun-ara-btn-active"
                                mandatory>
                    <v-btn value="name" class="text-caption" tile
                           :class="[urunAraData.urunAraType !== 'name' ? 'white' : '']">
                      <span class="text-capitalize">{{ $t("URUNLER.LIST_SEARCHBOX.SEARCHBOX_BTN_TOGGLE.TITLE") }}</span>
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-btn value="kod" class="text-caption" tile
                           :class="[urunAraData.urunAraType !== 'kod' ? 'white' : '']">
                      <span class="text-capitalize">{{ $t("URUNLER.LIST_SEARCHBOX.SEARCHBOX_BTN_TOGGLE.PRODUCT_CODE")
                        }}</span>
                    </v-btn>
                  </v-btn-toggle>
                  <v-btn depressed icon class="urun-ara-btn" @click="urunAraEnter">
                    <v-icon color="black">mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="py-0">
        <div v-if="isDesktop" class="d-flex justify-end">
          <div>
            <transition name="fade">
              <v-btn
                v-show="topluIslemler"
                color="transparent"
                class="font-weight-regular mr-2"
                depressed
                small
                plain
                :retain-focus-on-click="false"
                tag="div"
                :ripple="false"
                :style="[topluIslemler ? { 'transition-delay': '.3s' } : {}]"
              >
                <span
                  v-if="selectionUrunler.length > 0">
                  {{ $t("URUNLER.SUB_HEADER.MASS_SELECTION_TEXT", { COUNT: selectionUrunler.length }) }}
                </span>
                <span v-else
                      class="text-caption text-capitalize grey--text text--darken-1">{{ $t("URUNLER.SUB_HEADER.MAKE_SELECTION_TEXT")
                  }}</span>
              </v-btn>
            </transition>
            <v-tooltip bottom color="black darken-2">
              <template v-slot:activator="{ on, attrs }">
                <transition name="fade">
                  <v-btn
                    v-show="topluIslemler"
                    v-on="on"
                    v-bind="attrs"
                    small
                    :dark="!selectedRowStatus"
                    class="font-weight-light mr-3"
                    color="green"
                    disabled-color="red"
                    :disabled="selectedRowStatus"
                    :style="[topluIslemler ? { 'transition-delay': '.2s' } : {}]"
                    @click="urunleriYayinaAl"
                  >
                    <v-icon left>mdi-chevron-right</v-icon>
                    {{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.PUBLISH_BTN") }}
                  </v-btn>
                </transition>
              </template>
              <span>{{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.PUBLISH_BTN_TOOLTIP") }}</span>
            </v-tooltip>
            <v-tooltip bottom color="black darken-2">
              <template v-slot:activator="{ on, attrs }">
                <transition name="fade">
                  <v-btn
                    v-show="topluIslemler"
                    v-on="on"
                    v-bind="attrs"
                    small
                    :dark="!selectedRowStatus"
                    class="font-weight-light mr-3"
                    color="orange"
                    :disabled="selectedRowStatus"
                    :style="[topluIslemler ? { 'transition-delay': '.1s' } : {}]"
                    @click="urunleriYayindanKaldir"
                  >
                    <v-icon left>mdi-chevron-right</v-icon>
                    {{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.UNPUBLISH_BTN") }}
                  </v-btn>
                </transition>
              </template>
              <span>{{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.UNPUBLISH_BTN_TOOLTIP") }}</span>
            </v-tooltip>
            <v-tooltip bottom color="black darken-2">
              <template v-slot:activator="{ on, attrs }">
                <transition name="fade">
                  <v-btn
                    v-show="topluIslemler"
                    v-on="on"
                    v-bind="attrs"
                    small
                    :dark="!selectedRowStatus"
                    class="font-weight-light mr-3"
                    color="red darken-2"
                    :disabled="selectedRowStatus"
                    @click="urunleriSistemdenKaldir"
                  >
                    <v-icon left>mdi-chevron-right</v-icon>
                    {{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.DELETE_BTN") }}
                  </v-btn>
                </transition>
              </template>
              <span>{{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.DELETE_BTN_TOOLTIP") }}</span>
            </v-tooltip>
          </div>
          <div>
            <v-btn v-if="!topluIslemler" small dark class="font-weight-light" color="primary"
                   @click="topluIslemler = true">
              <v-icon left>mdi-selection-drag</v-icon>
              {{ $t("URUNLER.SUB_HEADER.MASS_SELECTION_BTN") }}
            </v-btn>
            <v-btn v-else small dark class="font-weight-light" color="black" @click="topluIslemlerIptal">
              <v-icon left>mdi-select-off</v-icon>
              {{ $t("URUNLER.SUB_HEADER.MASS_SELECTION_CANCEL_BTN") }}
            </v-btn>
          </div>
        </div>
        <div class="d-flex justify-end" v-else>
          <v-menu v-model="topluIslemler" offset-y="10">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark class="font-weight-light" color="primary" v-on="on" v-bind="attrs">
                <v-icon left>mdi-selection-drag</v-icon>
                {{ $t("URUNLER.SUB_HEADER.MASS_SELECTION_BTN") }}
              </v-btn>
            </template>
            <v-list dense width="auto">
              <v-list-item @click="urunleriYayinaAl">
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="text-body-2 font-weight-bold">
                  {{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.PUBLISH_BTN") }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="urunleriYayindanKaldir">
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="text-body-2 font-weight-bold">
                  {{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.UNPUBLISH_BTN") }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="urunleriSistemdenKaldir">
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="text-body-2 font-weight-bold">
                  {{ $t("URUNLER.SUB_HEADER.MASS_ACTIONS.DELETE_BTN") }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
      <v-col cols="12" lg="3">
        <v-card class="pb-5">
          <v-overlay :absolute="true" :value="urunFiltreOverlay" color="white" opacity="0.9">
            <div class="px-2 py-2">
              <div class="black--text text-center font-weight-light">
                <p v-html="$t('URUNLER.SEARCH_RESULT_TEXT', {TEXT: `<b>“${urunSonArama}”</b>` })"></p>
              </div>
              <div class="d-flex justify-center">
                <v-btn color="red darken-3" @click="urunAraData.urunAraText = ''" x-small outlined>
                  <v-icon small left>mdi-refresh</v-icon>
                  {{ $t("URUNLER.SEARCH_RESULT_RESET_BTN") }}
                </v-btn>
              </div>
            </div>
          </v-overlay>
          <v-col>
            <h3 class="text-body-1 font-weight-regular pb-2">
              <v-icon class="mb-1">mdi-filter-variant-plus</v-icon>
              {{ $t("URUNLER.FILTER_TITLE") }}
            </h3>
            <div class="px-1 mb-2">
              <v-divider></v-divider>
            </div>
          </v-col>
          <v-col class="pt-0">
            <v-chip small>
              <v-icon small class="mr-1">mdi-chevron-down</v-icon>
              {{ $t("URUNLER.FILTER_SUB_STATUS_TITLE") }}
            </v-chip>
            <v-radio-group v-model="urunFiltresi.aktifDurumFiltresi" mandatory hide-details class="filtre-durum-group">
              <v-sheet color="grey darken-3" class="rounded-xl px-2 py-1 mb-2">
                <v-radio :value="2" selected color="grey darken-3" @click="aktifDurumFiltresi">
                  <template v-slot:label>
                    <span class="text-caption grey--text text--darken-3">{{ $t("URUNLER.FILTER_OPTIONS.ALL") }}</span>
                  </template>
                </v-radio>
              </v-sheet>
              <v-sheet color="green lighten-1" class="white rounded-xl px-2 py-1 mb-2">
                <v-radio color="green lighten-1" :value="1" @click="aktifDurumFiltresi">
                  <template v-slot:label>
                    <span
                      class="text-caption green--text text--lighten-1">{{ $t("URUNLER.FILTER_OPTIONS.JUST_PUBLISHED")
                      }}</span>
                  </template>
                </v-radio>
              </v-sheet>
              <v-sheet color="orange lighten-1" class="rounded-xl px-2 py-1 mb-2">
                <v-radio color="orange lighten-1" :value="0" @click="aktifDurumFiltresi">
                  <template v-slot:label>
                    <span
                      class="text-caption orange--text text--lighten-1">{{ $t("URUNLER.FILTER_OPTIONS.JUST_UNPUBLISHED")
                      }}</span>
                  </template>
                </v-radio>
              </v-sheet>
            </v-radio-group>
          </v-col>
          <v-col class="pt-1">
            <v-chip small>
              <v-icon small class="mr-1">mdi-chevron-down</v-icon>
              {{ $t("URUNLER.FILTER_SUB_CATEGORY_FILTER_TITLE") }}
            </v-chip>
          </v-col>
          <v-treeview
            class="text-body-2"
            v-model="selection"
            :items="kategoriListesi"
            selection-type="independent"
            open-on-click
            selected-color="primary"
            selectable
            :open-all="openTree"
            :open="urunFiltresi.aktifKategoriler"
            dense
          ></v-treeview>
        </v-card>
      </v-col>
      <v-col cols="12" lg="9">
        <v-data-table
          v-model="selectionUrunler"
          item-key="code"
          :headers="headers"
          :items="urunListesi"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          class="elevation-1"
          @page-count="pageCount = $event"
          :loading="listStatus"
          :loading-text="$t('URUNLER.LIST.LOADING_TABLE_DATA')"
          :no-data-text="noDataText"
          :show-select="topluIslemler"
          :server-items-length="urunSayisi"
          calculate-widths
        >
          <template v-slot:item.kod="{ item }">
            <span class="font-weight-light text-caption text-center">
              {{ item.kod }}
            </span>
          </template>
          <template v-slot:item.resimler="{ item }">
            <div class="d-flex align-center pa-2">
              <v-img v-if="item.varyasyonlar[0].images.length > 0" :key="key" v-for="(img, key) in item.varyasyonlar[0].images.slice(0, 2)" max-width="35px" class="rounded-lg mr-1"
                     :src="item.varyasyonlar[0].imageCollection[img].small"
                     :name="img"
              ></v-img>
              <div v-if="item.varyasyonlar[0].images.slice(2).length > 0" class="blue-grey--text">
                + {{item.varyasyonlar[0].images.slice(2).length}}
              </div>
            </div>
          </template>
          <template v-slot:item.name="{ item }">
            <span class="font-weight-bold">{{ item.name }}</span>
          </template>
          <template v-slot:item.varyasyonlar="{ item }">
            <v-btn x-small rounded class="text-capitalize" color="info" depressed
                   @click="openVaryasyonListesi(item.code)">
              <v-icon size="15" class="mr-1">mdi-eye</v-icon>
              {{ $t("URUNLER.LIST.LIST_VARIATIONS_BTN") }}
            </v-btn>
          </template>
          <template v-slot:item.publish="{ item }">
            <div class="mx-auto">
              <v-switch
                class="durum-switch"
                color="success"
                hide-details
                @change="yayinDurumunuDegistir($event, item.code)"
                inset
                :input-value="boolCevir(item.publish)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-tooltip bottom color="blue">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs" icon small :to="`./urun-duzenle/${item.code}`">
                    <v-icon color="grey" size="18">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("URUNLER.LIST.EDIT_PRODUCT_BTN") }}</span>
              </v-tooltip>
              <v-btn icon small @click="sistemdenKaldirOnay(item.code)">
                <v-icon color="grey" size="18">mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount" @input="pageClick"></v-pagination>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="sistemdenKaldirDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("URUNLER.DELETE_PRODUCT_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("URUNLER.DELETE_PRODUCT_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="sistemdenKaldirDialog = false">
            {{ $t("URUNLER.DELETE_PRODUCT_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="sistemdenKaldirOnayStatus" @click="sistemdenKaldir">
            {{ $t("URUNLER.DELETE_PRODUCT_DIALOG.OK_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Varyasyon Listesi -->
    <v-dialog scrollable v-if="urunVaryasyonDialog.urunData" v-model="urunVaryasyonDialog.dialog" max-width="1000">
      <v-card>
        <v-card-title class="blue white--text">
          <div class="text-subtitle-1 font-weight-medium">
            <v-icon left color="blue darken-4">mdi-format-list-text</v-icon>
            {{ $t("URUNLER.VARIATION_LIST_DIALOG.TITLE") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="urunVaryasyonDialog.dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <v-list class="pt-0">
            <v-list-item class="grey lighten-3">
              <v-list-item-content>
                <v-list-item-title class="text-subtitle-2">
                  <v-chip class="mr-2 px-5" small>{{ $t("URUNLER.VARIATION_LIST_DIALOG.QUALIFICATIONS_TEXT") }}</v-chip>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="text-subtitle-2">
                <div>
                  <v-chip class="mr-2 px-5" small>{{ $t("URUNLER.STOCK_TEXT") }}</v-chip>
                  <v-chip class="mr-1 px-5" small>{{ $t("URUNLER.PRICE_TEXT") }}</v-chip>
                </div>
              </v-list-item-action>
            </v-list-item>
            <div :key="key" v-for="(varyasyon, key) in varyasyonListesi">
              <v-list-item v-if="varyasyon.status">
                <v-list-item-content>
                  <v-list-item-title v-if="varyasyon.attrs.length">
                    <v-chip color="grey lighten-3" class="mr-1" small :key="nitelik" v-for="nitelik in varyasyon.attrs">
                      {{ nitelikDetay(nitelik).name }}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    <v-chip color="grey lighten-3" class="mr-1" small>
                      {{ $t("URUNLER.SINGLE_PRODUCT") }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <div>
                    <v-tooltip top color="red" v-if="varyasyon.discount">
                      <template #activator="{ on, attrs }">
                        <v-chip v-on="on" v-bind="attrs" class="px-0 mr-1" color="transparent" small>
                          <v-icon color="red">mdi-flash</v-icon>
                        </v-chip>
                      </template>
                      <span>
                        <strong> <v-icon color="white"
                                         size="15">mdi-flash</v-icon>{{ $t("URUNLER.VARIATION_LIST_DIALOG.PRODUCT_ON_SALE")
                          }}: </strong>
                        <br />
                        {{ $t("URUNLER.OLD_PRICE_TEXT") }}: {{ varyasyon.oldPrice }} ₺
                        <br />
                        {{ $t("URUNLER.NEW_PRICE_TEXT") }}: {{ varyasyon.price }} ₺
                      </span>
                    </v-tooltip>
                    <v-chip class="font-weight-medium mr-1" color="indigo" dark small>
                      {{ $t("URUNLER.TOTAL", { COUNT: varyasyon.stock }) }}
                    </v-chip>
                    <v-chip class="font-weight-medium" color="success" small>
                      {{ $t("URUNLER.PRICE", { TEXT: varyasyon.price }) }}
                    </v-chip>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="info" @click="urunVaryasyonDialog.dialog = false">
            <v-icon left>mdi-close-circle</v-icon>
            {{ $t("URUNLER.VARIATION_LIST_DIALOG.CLOSE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Varyasyon Listesi -->
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "UrunList",
  data() {
    return {
      listStatus: true,
      kategoriListesi: [],
      aktifKategoriAdlari: [],
      selection: [],
      selectionUrunler: [],
      baslangic: 0,
      limit: 10,
      page: 1,
      lastPage: 0,
      pageCount: 0,
      itemsPerPage: 10,
      noDataText: this.$t("URUNLER.LIST.NO_PRODUCT_ADDITIONAL"),
      topluIslemler: false,
      options: {},
      /**
       * Ürün arama alanı verileri
       */
      urunAraData: {
        urunAraSelect: "",
        urunAraText: "",
        urunAraType: "name"
      },
      /**
       * Ürün filtre alanı verileri
       */
      urunFiltresi: {
        aktifDurumFiltresi: 2,
        aktifKategoriler: []
      },
      headers: [
        {
          text: this.$t("URUNLER.LIST.TABLE_FIELDS.CODE"),
          align: "start",
          sortable: false,
          value: "kod"
        },
        { text: this.$t("URUNLER.LIST.TABLE_FIELDS.PREVIEW"), value: "resimler", sortable: false },
        { text: this.$t("URUNLER.LIST.TABLE_FIELDS.TITLE"), value: "name", sortable: false },
        { text: this.$t("URUNLER.LIST.TABLE_FIELDS.VARIATIONS"), value: "varyasyonlar", sortable: false },
        { text: this.$t("URUNLER.LIST.TABLE_FIELDS.STATUS"), value: "publish", sortable: false },
        { text: this.$t("URUNLER.LIST.TABLE_FIELDS.ACTIONS"), value: "actions", sortable: false }
      ],
      openTree: false,
      lastID: 0,
      urunSayisi: 0,
      urunFiltreOverlay: false,
      urunSonArama: "",
      sistemdenKaldirUrunCode: "",
      sistemdenKaldirDialog: false,
      sistemdenKaldirOnayStatus: false,
      defaultColor: "#353535",
      urunVaryasyonDialog: {
        dialog: false,
        urunData: null
      }
    };
  },
  computed: {
    ...mapState({
      urunListesi: state => state.Urunler.UrunList.urunListesi,
      urunKategorileri: state => state.Urunler.UrunCategories.kategoriListesi,
      urunAramaSonucu: state => state.Urunler.UrunList.urunAramaSonucu
    }),
    selectedRowStatus() {
      return this.selectionUrunler.length > 0 ? false : true;
    },
    /**
     * @returns {String}
     */
    apiUrl() {
      return this.$ApiUrl;
    },
    /**
     * @returns {Object}
     */
    nitelikListesi() {
      return this.urunVaryasyonDialog.urunData.nitelikler;
    },
    /**
     * @returns {Array}
     */
    varyasyonListesi() {
      return this.urunVaryasyonDialog.urunData.varyasyonlar;
    },
    isDesktop() {
      return this.$vuetify.breakpoint.lgAndUp;
    }
  },
  methods: {
    formatFiyat(fiyat) {
      var formatter = new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      });
      return formatter.format(fiyat).replace("₺", "");
    },
    boolCevir(d) {
      return !!parseInt(d);
    },
    idCounter() {
      return this.lastID++;
    },
    openVaryasyonListesi(code) {
      this.urunVaryasyonDialog.urunData = this.urunListesi.find(o => o.code == code);
      this.urunVaryasyonDialog.dialog = true;
    },
    nitelikDetay(code) {
      return this.nitelikListesi[code];
    },
    kategoriParser(cats, parent = []) {
      if (parent.length === 0) {
        /**
         * En üst kategoriyi al
         */
        parent = _.find(cats, { parent: 0 });
      }

      /**
       * Üst kategoriyi kaldır
       */
      var catList = _.remove(cats, o => {
        return o.parent !== 0;
      });

      /**
       * Listeden alt kategoriyi/kategorileri getir
       */
      var cat = _.filter(catList, {
        parent: parent.code
      });

      /**
       * Alt kategorileri tekrar tekrar oluştur
       */
      if (cat.length > 0) {
        parent.children = [];
        cat.forEach(d => {
          parent.children.push(this.kategoriParser(JSON.parse(JSON.stringify(catList)), JSON.parse(JSON.stringify(d))));
        });
      }

      /**
       * ID numarası ekle
       */
      parent.id = this.idCounter();

      /**
       * Sonucu döndür
       */
      return parent;
    },
    findID(catList, id) {
      var result;
      catList.forEach(cat => {
        if (cat.id === id) {
          return (result = cat);
        } else if (cat.children) {
          let find = this.findID(cat.children, id);
          return (result = find ? find : result);
        }
      });
      return result;
    },
    topluIslemlerIptal() {
      /**
       * Toplu işlemler butonu deaktif
       * edildiğinde
       */
      this.topluIslemler = false;
      this.selectionUrunler = [];
    },
    urunListesiniGetir() {
      const baslangic = this.baslangic;
      const limit = this.limit;
      const kategoriListesi = this.aktifKategoriAdlari;
      const durum = this.urunFiltresi.aktifDurumFiltresi;
      this.listStatus = true;
      this.$store
        .dispatch("Urunler/UrunList/urunListesi", {
          baslangic,
          limit,
          kategoriListesi,
          durum
        })
        .then(() => {
          this.listStatus = false;
        });
      this.urunListeSayisi();
    },
    /**
     * Listelenen ürünün ürün listesi, filtrelenmiş
     * ürün listesi veya arama sonucu listesine göre
     * pagination'ını verir
     */
    urunListeSayisi() {
      const kategoriListesi = this.aktifKategoriAdlari;
      const durum = this.urunFiltresi.aktifDurumFiltresi;
      this.$store.dispatch("Urunler/UrunList/urunSayisi", { kategoriListesi, durum }).then(res => {
        this.urunSayisi = parseInt(res.data);
      });
    },
    /**
     * Arama sonucuna göre bulunan ürünlerin
     * sayısını verir
     */
    urunAraSayisi() {
      const ara = this.urunAraData.urunAraText;
      const kategori = this.urunAraData.urunAraSelect;
      const type = this.urunAraData.urunAraType;
      this.$store.dispatch("Urunler/UrunList/urunAraSayisi", { ara, kategori, type }).then(res => {
        this.urunSayisi = parseInt(res.data);
      });
    },
    /**
     * Ürün arama işlemini gerçekleştir
     */
    urunAra() {
      const ara = this.urunAraData.urunAraText;
      const kategori = this.urunAraData.urunAraSelect ? this.urunAraData.urunAraSelect : null;
      const type = this.urunAraData.urunAraType;
      const baslangic = this.baslangic;
      const limit = this.limit;
      this.listStatus = true;
      this.$store
        .dispatch("Urunler/UrunList/urunAra", {
          ara,
          type,
          kategori,
          baslangic,
          limit
        })
        .then(res => {
          this.listStatus = false;
          if (res.status !== 200) {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          } else {
            this.$store.commit("Urunler/UrunList/setUrunListesi", res.data);
            this.urunFiltreOverlay = true;
            this.urunSonArama = ara;
          }
          return res;
        })
        .then(res => {
          if (res.status === 200) this.urunAraSayisi();
        });
    },
    /**
     * Ürün arama işlemi enter veya btn ile
     * yapıldığında çalışır
     */
    urunAraEnter() {
      if (this.urunAraData.urunAraText !== "") this.paginationSifirla();

      this.urunAra();
    },
    /**
     * Durum filtresinden birisi seçildiğinde
     * istek at
     */
    aktifDurumFiltresi() {
      this.paginationSifirla();
      this.urunListesiniGetir();
    },
    pageClick(page) {
      if (page !== this.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.baslangic = this.page * this.itemsPerPage - this.itemsPerPage;

        if (!this.urunAraData.urunAraText) {
          /**
           * Ürün listesini getir
           */
          this.urunListesiniGetir();
        } else {
          /**
           * Arama var ise aramaya göre pagination getir
           */

          /**
           * Ürünü aram sonucunu pagination'a göre getir
           */
          this.urunAra();
        }
      }
    },
    paginationSifirla() {
      this.$store.commit("Urunler/UrunList/setUrunListesi", []);
      this.baslangic = 0;
      this.page = 1;
      this.urunSayisi = 0;
    },
    /**
     * Toplu işlemler:
     * Yayına Al
     */
    urunleriYayinaAl() {
      const urunCodeList = this.selectionUrunler.map(list => {
        return list.code;
      });
      this.$store.dispatch("Urunler/UrunList/urunleriYayinaAl", urunCodeList).then(res => {
        if (res.status === 200) {
          this.paginationSifirla();
          this.urunListesiniGetir();
          this.topluIslemlerIptal();
          this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCTS_PUBLISH_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    /**
     * Toplu işlemler:
     * Yayından kaldır
     */
    urunleriYayindanKaldir() {
      const urunCodeList = this.selectionUrunler.map(list => {
        return list.code;
      });
      this.$store.dispatch("Urunler/UrunList/urunleriYayindanKaldir", urunCodeList).then(res => {
        if (res.status === 200) {
          this.paginationSifirla();
          this.urunListesiniGetir();
          this.topluIslemlerIptal();
          this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCTS_UNPUBLISH_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    /**
     * Toplu işlemler:
     * Sistemden kaldır
     */
    urunleriSistemdenKaldir() {
      const urunCodeList = this.selectionUrunler.map(list => {
        return list.code;
      });
      this.$store.dispatch("Urunler/UrunList/urunleriSistemdenKaldir", urunCodeList).then(res => {
        if (res.status === 200) {
          this.paginationSifirla();
          this.urunListesiniGetir();
          this.topluIslemlerIptal();
          this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCTS_DELETION_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    /**
     * Herhangi bir ürün üzerindeki yayın durumunu
     * değiştirir
     */
    yayinDurumunuDegistir(e, urunCode) {
      if (e === true) {
        this.$store.dispatch("Urunler/UrunList/yayinaAl", urunCode).then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_PUBLISH_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
      } else {
        this.$store.dispatch("Urunler/UrunList/yayindanKaldir", urunCode).then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_UNPUBLISH_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
      }
    },
    sistemdenKaldirOnay(urunCode) {
      this.sistemdenKaldirUrunCode = urunCode;
      this.sistemdenKaldirDialog = true;
    },
    sistemdenKaldir() {
      const urunCode = this.sistemdenKaldirUrunCode;
      this.sistemdenKaldirOnayStatus = true;
      this.$store.dispatch("Urunler/UrunList/sistemdenKaldir", urunCode).then(res => {
        this.sistemdenKaldirOnayStatus = false;
        this.sistemdenKaldirDialog = false;
        if (res.status === 200) {
          this.$store.commit(
            "Urunler/UrunList/setUrunListesi",
            _.remove(this.urunListesi, o => {
              return o.code !== urunCode;
            })
          );
          this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_DELETION_SUCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    }
  },
  created() {
    /**
     * Ürün listesini getir
     */
    this.urunListesiniGetir();

    /**
     * Ürün kategorileri listesini getir
     */
    this.$store
      .dispatch("Urunler/UrunCategories/kategoriListesi")
      .then(res => {
        var grouped = _.mapValues(_.groupBy(res.data, "hierarchy"));
        var catList = [];
        Object.keys(grouped).forEach(groupKey => {
          catList.push(this.kategoriParser(JSON.parse(JSON.stringify(grouped[groupKey]))));
        });
        this.kategoriListesi = catList;
      })
      .then(() => {
        /**
         * Kapalı olan tüm kategori ağacını aktif et
         */
        for (var i = 0; i < this.lastID; i++) {
          this.urunFiltresi.aktifKategoriler.push(i);
        }
      });
  },
  watch: {
    /**
     * Kategori listesinden herhangi bir kategori
     * aktif edildiği zaman
     */
    selection() {
      var kategori = [];
      this.selection.forEach(sec => {
        let find = this.findID(this.kategoriListesi, sec);
        if (find) kategori.push(find.code);
      });
      this.aktifKategoriAdlari = kategori;
    },
    /**
     * Aktif Kategori adları her değiştiğinde ürün
     * listesini yeniden getir
     */
    aktifKategoriAdlari() {
      this.paginationSifirla();
      this.urunListesiniGetir();
    },
    /**
     * Sayfa değişiminde son geçilen sayfayı
     * bir değere at
     */
    page: {
      handler(page) {
        this.lastPage = page;
      },
      immediate: true
    },
    /**
     * Ürün arama işleminde kategori seçimi
     * iptal edildiğinde değerini boş olarak
     * ayarla
     */
    "urunAraData.urunAraSelect"(val) {
      if (!val) this.urunAraData.urunAraSelect = "";
    },
    "urunAraData.urunAraType"(val) {
      if (!val) this.urunAraData.urunAraType = "name";
    },
    "urunAraData.urunAraText"(val) {
      if (!val) {
        this.baslangic = 0;
        this.urunListesiniGetir();
        this.urunFiltreOverlay = false;
        this.urunAraData.urunAraSelect = "";
        this.urunAraData.urunAraType = "name";
        this.urunSonArama = "";
        // Clearable'da null'a çevirmekte, null dönerse "" at
        this.urunAraData.urunAraText = val ?? "";
      }
    }
  }
};
</script>

<style>
.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave-active {
  transition: none;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.urun-ara-btn {
  right: -5px;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined).urun-ara-btn-active:before {
  opacity: 0.05;
}

.urun-ara-text-field.v-text-field {
  position: relative;
}

.urun-ara-text-field.v-text-field .v-text-field__details {
  position: absolute;
  bottom: -16px;
  margin-bottom: 0;
  height: 0;
  width: 100%;
}

.urun-td-items *:last-child {
  margin-bottom: 0 !important;
}

.durum-switch {
  margin-top: 0;
  position: relative;
  left: 10px;
}
</style>

<style lang="sass" scoped>
.v-application .filtre-durum-group .v-sheet
  border-width: 1px
  border-style: solid
  background-color: transparent !important
</style>
